// import { Carousel } from 'react-bootstrap';
// import Header from '../../Header/Header';
// import TopNavbar from '../TopNavbar'
// import Footer from '../../Footer/Footer'
// import banner11 from '../img/banner11.png'

// function Contact() {
//   return (
//     <div>
//       <Header />
//       <TopNavbar />
//       <br></br>
//       <div className="banner-area">
//         <Carousel id="bootcarousel" className="text-light heading-uppercase animate_text" controls indicators={false}>
//           <Carousel.Item style={{ padding: "30px" }}>
//             <img src={banner11} className="d-block w-100" alt="Second slide" />
//           </Carousel.Item>
//         </Carousel>
//       </div>
//       <br></br>
//       <div>
//         <div style={{ maxWidth: '500px', color: 'red', width: '500px', height: "500px" }}><div id="embed-ded-map-canvas" style={{ height: '500px', width: '600px', maxWidth: "100%" }}><iframe style={{ height: '550px', width: '1305px', padding: "35px" }} frameborder="0" src="https://www.google.com/maps/embed/v1/place?q=https://www.google.co.in/maps/place/Lions+Bhavan+,+Paradise/&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe></div><a class="google-map-code-enabler" href="https://www.bootstrapskins.com/themes" id="get-data-for-embed-map">premium bootstrap themes</a><style>#embed-ded-map-canvas </style></div>
//       </div>
//       <br></br>
//       <Footer />
//     </div>
//   )
// }

// export default Contact











import { useState } from "react"
import Header from '../../Header/Header';
import TopNavbar from '../TopNavbar'
import Footer from '../../Footer/Footer'
import banner11 from '../img/banner11.png'

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" })
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://api.lionsmd320.org/pages/api/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });

      if (response.ok) {
        setSent(true);
      } else {
        alert('Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Network error:', error);
      alert('Error connecting to server.');
    }
  };

  return (
    <div style={{ fontFamily: "inherit", color: "#1f2937", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <Header />
      <TopNavbar />

      {/* Clean Responsive Hero Banner (Replacing Carousel) */}
      <div style={{ position: "relative", backgroundColor: "#0067B1", backgroundImage: `linear-gradient(rgba(0, 103, 177, 0.85), rgba(0, 50, 90, 0.9)), url(${banner11})`, backgroundSize: "cover", backgroundPosition: "center", padding: "60px 20px", textAlign: "center", color: "#ffffff" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <span style={{ display: "inline-block", fontSize: "12px", fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", backgroundColor: "rgba(255, 213, 0, 0.2)", color: "#FFD500", padding: "6px 14px", borderRadius: "20px", marginBottom: "16px", border: "1px solid rgba(255, 213, 0, 0.4)" }}>
            Get In Touch
          </span>
          <h1 style={{ fontSize: "clamp(28px, 4vw, 42px)", fontWeight: 800, margin: "0 0 12px 0", letterSpacing: "-0.02em" }}>
            We Are Here to Help
          </h1>
          <p style={{ fontSize: "16px", opacity: 0.9, maxWidth: "600px", margin: "0 auto", lineHeight: "1.5" }}>
            Have questions or want to connect with MD 320? Reach out to our team and we'll respond as soon as possible.
          </p>
        </div>
      </div>

      {/* Main Contact Section (Responsive Grid) */}
      <section style={{ padding: "60px 16px", backgroundColor: "#ffffff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "40px", alignItems: "start" }}>

            {/* Contact Info Card */}
            <div style={{ backgroundColor: "#ffffff", padding: "32px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)", border: "1px solid #e2e8f0" }}>
              <h2 style={{ fontSize: "22px", fontWeight: 800, color: "#0067B1", marginTop: "0", marginBottom: "24px", display: "flex", alignItems: "center", gap: "10px" }}>
                <span style={{ display: "inline-block", width: "4px", height: "20px", backgroundColor: "#FFD500", borderRadius: "2px" }}></span>
                Contact Information
              </h2>

              <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginBottom: "32px" }}>
                {[
                  { icon: "📍", label: "Address", value: "Lakpathi Building,\nBeside HDFC Bank,\nSecunderabad - 500003." },
                  { icon: "✉️", label: "Email", value: "lionsmd320@gmail.com" },
                  { icon: "📞", label: "Phone", value: "+91-9866014575\nMon–Fri 9:00 AM – 5:00 PM" },
                ].map((item) => (
                  <div key={item.label} style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                    <div style={{ width: "44px", height: "44px", backgroundColor: "#f0f7ff", border: "1px solid #dceeff", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", flexShrink: 0 }}>
                      {item.icon}
                    </div>
                    <div>
                      <div style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#64748b", marginBottom: "4px" }}>
                        {item.label}
                      </div>
                      <div style={{ color: "#334155", fontSize: "14px", lineHeight: "1.6", whiteSpace: "pre-line" }}>
                        {item.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Social Links */}
              <div style={{ borderTop: "1px solid #f1f5f9", paddingTop: "24px" }}>
                <div style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#64748b", marginBottom: "12px" }}>
                  Follow MD 320
                </div>
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  {[
                    { name: "Facebook", url: "https://www.facebook.com/lionsmd320" },
                    { name: "YouTube", url: "https://www.youtube.com/@lionsmd320" },
                    { name: "Instagram", url: "https://www.instagram.com/lionsmd320" }
                  ].map((s) => (
                    <a key={s.name} href={s.url} target="_blank" rel="noreferrer" style={{ padding: "8px 14px", backgroundColor: "#f8fafc", border: "1px solid #e2e8f0", color: "#0067B1", borderRadius: "8px", fontSize: "12px", fontWeight: 700, textDecoration: "none" }}>
                      {s.name}
                    </a>
                  ))}
                </div>
              </div>

              {/* Office Hours Box */}
              <div style={{ marginTop: "24px", backgroundColor: "#f8fafc", borderRadius: "12px", padding: "16px", border: "1px solid #e2e8f0" }}>
                <div style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#0067B1", marginBottom: "8px" }}>
                  Office Hours
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "13px", color: "#475569" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}><span>Mon – Fri:</span> <span style={{ fontWeight: 600 }}>9:00 AM – 5:00 PM</span></div>
                  <div style={{ display: "flex", justifyContent: "space-between" }}><span>Saturday:</span> <span style={{ fontWeight: 600 }}>10:00 AM – 2:00 PM</span></div>
                  <div style={{ display: "flex", justifyContent: "space-between" }}><span>Sunday:</span> <span style={{ fontWeight: 600 }}>Closed</span></div>
                </div>
              </div>
            </div>

            {/* Contact Form Card */}
            <div style={{ backgroundColor: "#ffffff", padding: "32px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)", border: "1px solid #e2e8f0" }}>
              <h2 style={{ fontSize: "22px", fontWeight: 800, color: "#0067B1", marginTop: "0", marginBottom: "24px", display: "flex", alignItems: "center", gap: "10px" }}>
                <span style={{ display: "inline-block", width: "4px", height: "20px", backgroundColor: "#FFD500", borderRadius: "2px" }}></span>
                Send a Message
              </h2>

              {sent ? (
                <div style={{ backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "12px", padding: "40px 24px", textAlign: "center" }}>
                  <div style={{ width: "56px", height: "56px", backgroundColor: "#22c55e", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px auto", color: "#ffffff", fontSize: "24px", fontWeight: "bold" }}>
                    ✓
                  </div>
                  <h3 style={{ fontSize: "18px", fontWeight: 800, color: "#166534", marginBottom: "8px" }}>Message Sent Successfully!</h3>
                  <p style={{ color: "#15803d", fontSize: "14px", marginBottom: "20px" }}>
                    Thank you {form.name}. We have received your inquiry and will reply to {form.email} shortly.
                  </p>
                  <button
                    onClick={() => { setSent(false); setForm({ name: "", email: "", subject: "", message: "" }) }}
                    style={{ backgroundColor: "#166534", color: "#ffffff", border: "none", padding: "10px 20px", borderRadius: "8px", fontWeight: 600, fontSize: "13px", cursor: "pointer" }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px" }}>
                    <div>
                      <label style={{ display: "block", fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#64748b", marginBottom: "6px" }}>
                        Your Name *
                      </label>
                      <input
                        type="text"
                        required
                        value={form.name}
                        onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                        placeholder="John Doe"
                        style={{ width: "100%", border: "1px solid #cbd5e1", borderRadius: "8px", padding: "12px", fontSize: "14px", color: "#1e293b", outline: "none", boxSizing: "border-box", backgroundColor: "#f8fafc" }}
                      />
                    </div>
                    <div>
                      <label style={{ display: "block", fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#64748b", marginBottom: "6px" }}>
                        Email Address *
                      </label>
                      <input
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                        placeholder="john@example.com"
                        style={{ width: "100%", border: "1px solid #cbd5e1", borderRadius: "8px", padding: "12px", fontSize: "14px", color: "#1e293b", outline: "none", boxSizing: "border-box", backgroundColor: "#f8fafc" }}
                      />
                    </div>
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#64748b", marginBottom: "6px" }}>
                      Subject *
                    </label>
                    <input
                      type="text"
                      required
                      value={form.subject}
                      onChange={(e) => setForm((f) => ({ ...f, subject: e.target.value }))}
                      placeholder="How can we assist you?"
                      style={{ width: "100%", border: "1px solid #cbd5e1", borderRadius: "8px", padding: "12px", fontSize: "14px", color: "#1e293b", outline: "none", boxSizing: "border-box", backgroundColor: "#f8fafc" }}
                    />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#64748b", marginBottom: "6px" }}>
                      Message *
                    </label>
                    <textarea
                      required
                      value={form.message}
                      onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
                      placeholder="Write your message details here..."
                      rows={5}
                      style={{ width: "100%", border: "1px solid #cbd5e1", borderRadius: "8px", padding: "12px", fontSize: "14px", color: "#1e293b", outline: "none", boxSizing: "border-box", backgroundColor: "#f8fafc", resize: "vertical" }}
                    />
                  </div>
                  <button
                    type="submit"
                    style={{
                      width: "100%",
                      backgroundColor: "#0067B1",
                      color: "#ffffff",
                      fontWeight: 700,
                      padding: "14px",
                      borderRadius: "8px",
                      border: "none",
                      cursor: "pointer",
                      letterSpacing: "0.05em",
                      fontSize: "14px",
                      boxShadow: "0 4px 12px rgba(0, 103, 177, 0.25)",
                    }}
                  >
                    Send Message
                  </button>
                </form>
              )}
            </div>

          </div>
        </div>
      </section>

      {/* Map Section */}
      <section style={{ padding: "40px 16px", backgroundColor: "#f1f5f9" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <h3 style={{ fontSize: "20px", fontWeight: 800, color: "#0067B1", margin: "0 0 6px 0" }}>Our Location</h3>
            <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Visit our headquarters or find us on the map below.</p>
          </div>
          <div style={{ height: "450px", width: "100%", borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)", border: "1px solid #cbd5e1" }}>
            <iframe
              style={{ height: "100%", width: "100%", border: 0 }}
              frameBorder="0"
              src="https://www.google.com/maps/embed/v1/place?q=https://www.google.co.in/maps/place/Lions+Bhavan+,+Paradise/&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
              title="Lions Bhavan Location"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}